import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const NavigationCommunitiesBoundary = () =>
  import(/* webpackChunkName: "4-feat-navigationcommunities" */ './NavigationCommunitiesBoundary');

const LoadableNavigationCommunities = lazyLoadOnRender({ loader: NavigationCommunitiesBoundary });

export default LoadableNavigationCommunities;
